import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  signal
} from '@angular/core';
import {L1L3AuthService} from 'ngx-auth-util-lib';
import {HekaAccountMenu} from 'ngx-heka-design-lib';
import {Subscription} from 'rxjs';
import {AccountMenuService} from 'src/app/services/account-menu.service';
import {DomainHandlerService} from 'src/app/services/domain-handler-service';
import {MultiDomainMgmtService} from 'src/app/services/multi-domain-mgmt.service';
import {environment} from '../../../environments/local/environment';
import {LoadingService} from '../../services/loading/loading.service';

@Component({
  selector: 'ngx-l2-minimal-menu-bar',
  templateUrl: './l2-minimal-menu-bar.component.html',
  styleUrls: ['./l2-minimal-menu-bar.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class L2MinimalMenuBarComponent implements AfterViewInit, OnDestroy {
  readonly accountMenu = signal<HekaAccountMenu | undefined>(undefined);
  readonly env = environment;

  private readonly subscriptions = new Subscription();
  private initializationTimer?: ReturnType<typeof setTimeout>;

  constructor(
    public loadingService: LoadingService,
    public authService: L1L3AuthService,
    public accountMenuService: AccountMenuService,
    public multiDomainMgmtService: MultiDomainMgmtService,
    public domainHandlerService: DomainHandlerService
  ) {}

  ngAfterViewInit(): void {
    this.initializationTimer = setTimeout(() => {
      this.subscriptions.add(
        this.multiDomainMgmtService.getSharedMultiDomainProfile().subscribe({
          next: profile => {
            if (profile) {
              this.accountMenu.set(
                this.accountMenuService.buildAccountMenu(profile)
              );
            }
          }
        })
      );

      this.subscriptions.add(
        this.multiDomainMgmtService.getMultiDomainProfile().subscribe()
      );
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.initializationTimer);
    this.subscriptions.unsubscribe();
  }
}